import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import FacebookIcon from "assets/images/share-buttons/share-facebook.png";
import { useFacebook } from "hooks";
import { uiShare } from "utils/facebookUtils";
import ResponsiveImage from "components/ResponsiveImage";

const FacebookInAppShare = ({ url, classes, handleTracking }) => {
  const { initialized } = useFacebook(true);

  const handleFacebookShareInApp = () => {
    if (!initialized) return;

    if (handleTracking) handleTracking();
    uiShare(url);
  };

  return (
    <button
      type="button"
      className={classes.shareButton}
      onClick={handleFacebookShareInApp}
      data-testid="shareoptions-facebook-inapp"
    >
      <ResponsiveImage
        className={classes.image}
        src={FacebookIcon}
        alt="Share on Facebook"
        width={94}
        widthMobile={48}
      />
      <Typography variant="caption" className={classes.name}>
        Facebook
      </Typography>
    </button>
  );
};

FacebookInAppShare.propTypes = {
  url: PropTypes.string,
  classes: PropTypes.node,
  handleTracking: PropTypes.func,
};

export default FacebookInAppShare;
